import {getKeyTitle} from "../js/tool";

export const roomColumns = [
    {title: '酒店名称', dataIndex: 'hotel_name', customRender: (text, record) => record.hotel ? record.hotel.name : '--'},
    {title: '酒店地址', dataIndex: 'hotel_address', customRender: (text, record) => record.hotel ? record.hotel.location : '--'},
    {title: '房型', dataIndex: 'type'},
    {title: '入住人数', dataIndex: 'need_num', customRender: (text, record) => `${record.hotelAllocation ? record.hotelAllocation.length : 0}/${record.count * text}`},
];

export const roomTypeList = [
    {key: 1, value: '单人间'},
    {key: 2, value: '标准间'},
]

export const getRoomTypeText = function (type) {
    return getKeyTitle(roomTypeList, type);
}

export const getHotelRoomType = function (hotel) {
    let res = '';
    const hotelRoom = hotel.room;
    if(hotelRoom && hotelRoom.length > 0) {
        res = hotelRoom.map(item => item.type).join(",");
    }
    return res;
}
